<template>
  <div class="file-pres file-pres-add m-b-20"
       @click="viewPrescription">
    <div class="file-pres__main">
      <span class="file-icon ns-icon-ico012 ns-x-large-icon" slot="icon"/>
      <div :class="{'m-l-10': !$isDesktop}">
        <div :class="$isDesktop ? 'Title2' : 'Title1'">{{ computedListTitle }}</div>
        <text-string class="m-t-15" :label-id="$isDesktop ? 'txt040__desktop' : 'txt040'" :props="computedPatientName"/>
        <div class="gray-400" :class="[{'m-t-5': $isDesktop}, $isDesktop ? 'Label1' : 'Body3']">
          {{ item.received | displayDateString }}
        </div>
      </div>
    </div>
    <div class="file-pres__coupon m-t-25 m-b-10"
         v-if="!hideCoupon && !$isDesktop">
      <smd-coupon :class="{'m-b-20': item.coupons.length > 1 && index !== item.coupons.length - 1}"
                  v-for="(coupon, index) in item.coupons"
                  :key="index"
                  :item="coupon"
                  :image="couponImage"
                  :small="true"
                  :title="coupon.shortname"/>
    </div>
    <div class="smd-panel__footer"
         :class="[{'file-pres-add__right_btns': $isDesktop}, {'m-t-20': !$isDesktop}]">
      <div class="file-pres__coupon"
           v-if="!hideCoupon && $isDesktop">
        <smd-coupon :class="{'m-b-20': item.coupons.length > 1 && index !== item.coupons.length - 1}"
                    v-for="(coupon, index) in item.coupons"
                    :key="index"
                    :item="coupon"
                    :image="couponImage"
                    :small="true"
                    :title="coupon.shortname"/>
      </div>
      <smd-btn class="file-pres-add__view-btn"
               section="5"
               variant="left-enabled"
               v-else>
        <text-string label-id="txt060__desktop"/>
      </smd-btn>
      <smd-btn class="file-pres-add__add-btn"
               section="5"
               :disabled="disabledAdd"
               :variant="computedAddBtnVariant"
               @click.stop.prevent="addPrescription">
        <text-string label-id="txt063__desktop"/>
      </smd-btn>
    </div>
  </div>
</template>

<script>
  import {formatDate} from "@/utils/dates";
  import {getPrescriptionCoupon} from '@/utils/medicine';
  import {getCouponLogo} from '@/reference/coupon';

  export default {
    name: "file-pres-add",
    props: {
      item: {type: Object},
      disabledAdd: {type: Boolean, default: false},
      hideCoupon: {type: Boolean, default: false}
    },
    computed: {
      computedAddBtnVariant() {
        return this.disabledAdd ? 'right-blue-disabled' : 'right-blue-enabled';
      },
      computedListTitle() {
        let stringType = '';

        switch (this.item.pagetype) {
          case 'prescription':
            stringType = 'Prescription';
            break;
          case 'image':
            stringType = 'Image';
            break;
          case 'customform':
            stringType = this.item.customform;
            break;
        }

        return `${stringType} from ${this.item.doctorname}`
      },
      computedPatientName() {
        return {'strings': [this.item.patientname, '']}
      },
      couponImage() {
        const coupon = getPrescriptionCoupon(this.item);
        return getCouponLogo(coupon);
      },
    },
    methods: {
      addPrescription() {
        this.$emit('add');
      },
      viewPrescription() {
        this.$emit('view');
      }
    },
    filters: {
      displayDateString(isoDate) {
        const date = formatDate(isoDate, 'MMM DD, YYYY');
        const time = formatDate(isoDate, 'h:mm A');
        return `Sent on ${date} at ${time}`
      },
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .file-pres-add {
    @include responsive(desktop) {
      display: grid;
      grid-template-columns: 1fr 235px;
      align-items: center;
      min-height: 160px;
      padding: space(m-base);
      overflow: hidden;
    }

    .file-icon {
      @include responsive(desktop) {
        font-size: 120px !important;
        margin-right: space(m-base);
      }
    }

    .file-pres__main {
      align-items: center;
    }
  }

  .file-pres-add__right_btns {
    @include responsive(desktop) {
      flex-direction: column;
      margin: unset;

      > button {
        width: 100%;
        max-width: 235px;
        min-width: 235px;
        min-height: 68px;
        margin-top: 12px;
      }
    }
  }

  //.file-pres-add__view-btn,
  //.file-pres__coupon {
  //  @extend %layout--flex-center-xy;
  //  @include responsive(desktop) {
  //    position: absolute;
  //    top: 0;
  //    right: 0;
  //    height: 90px;
  //    width: 235px;
  //  }
  //}

  .file-pres-add__right_btns {
    .file-pres__coupon, .file-pres-add__view-btn {
      @extend %layout--flex-center-xy;
      @include responsive(desktop) {
        position: absolute;
        top: 0;
        right: 0;
        height: 90px;
        width: 235px;
      }
    }
  }

  .file-pres-add__add-btn {
    position: absolute;
    bottom: 0 !important;
    right: 0 !important;
  }
</style>